
<app-page-header (myEvent)="refreshPage()">{{'otp_setting_title' | translate }}</app-page-header> <!--page header-->

 <div id="appCapsule">
    <div class="container">
         <button class="btn btn-secondary" (click)="goBack()">
           <ion-icon name="arrow-back"></ion-icon>Back
        </button>
        <h3 class="text_message_warning">{{ 'otp_setting_warning_message' | translate }}</h3>
        <h3 class="text-center text-white mt-3">{{'otp_setting_desc3' | translate }}</h3>
            <!-- {{ otpChannelList | json}} -->
        <div class="row">
            <div class="col-12 mt-2 otp__setting" *ngFor="let otpChannel of otpChannelList;trackBy: trackByOtpChannelList">
                <div class="card">
                    <div class="card-body text-center" >   
                           <img [src]="otpChannel.icon_url" class="img-fluid" alt="icon" style="width: 40px; height: 40px;" />
                           <div class="ml-2 text-left">
                                <h4>{{otpChannel.channel_name}}</h4>
                                <p *ngIf="otpChannel.channel_code === 'SMS'">{{ 'sms_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'VIBER'">{{ 'viber_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'TELEGRAM'">{{ 'telegram_des' | translate : {value: otpChannel.destination_masked} }}   </p>
                                <p *ngIf="otpChannel.channel_code === 'EMAIL'">{{ 'email_des' | translate : {value: otpChannel.destination_masked== null?'******@gmail.com': otpChannel.destination_masked} }}   </p>
                                <div class="mb-3" *ngIf="otpChannel.channel_code === 'EMAIL' && otpChannel.destination === null && otpChannel.channel_id === selectedChannel.channel_id">
                                    <label for="exampleInputEmail1" class="form-label">Email address</label>             
                                    <input type="email" class="form-control" placeholder="Enter your email"  name="email"
                                     [(ngModel)]="email"  #emailRef="ngModel" (input)="checkEmail(emailRef)" />                                    
                                      <div *ngIf="emailRef.invalid && emailRef.touched" class="error-color">{{ 'invalid_email' | translate }}</div>                    
                                </div>
                            </div>
                           
                                      
                    </div>
                </div>
            </div>         
        </div>
        <p class="text-center text-white mt-3">{{'otp_setting_desc1' | translate : {value: selectedChannel.channel_name} }}</p>
        <!-- <button class="btn btn-primary btn-block mt-3" (click)="onSaveOtpSetting()">{{ 'save' | translate }}</button> -->

    </div>   
    
</div>
<ngx-spinner name="refreshLoading" bdOpacity=0.9 size="medium" color="#00acc1" type="ball-spin-clockwise"
    [fullScreen]="true"></ngx-spinner>